export default "__VITE_ASSET__0f130616__"